<template>
  <div class="h-100">
    <!-- <CardBase :classCard="'d-none d-md-none d-lg-block h-100 border-0 shadow-sm bg-white'">
      <template #body>
        <MenuSidebarContent />
      </template>
    </CardBase> -->

    <MenuOffCanvas :classCard="'d-block'" :classCardBody="'pt-1 px-5'">
      <!-- Aquí va el contenido del sidebar -->
      <template #body>
        <MenuSidebarContent />
      </template>
    </MenuOffCanvas>
  </div>
</template>

<script setup>
import MenuOffCanvas from '@/components/layout/admin/menu/MenuOffCanvas.vue'
import MenuSidebarContent from '@/components/layout/admin/menu/MenuSidebarContent.vue'
</script>
